import { Fragment } from "react";
import { Grid as MuiGrid, useMediaQuery } from "@mui/material";

import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IContract } from "@framework/types";

import { ContractListItem } from "../../../../components";

export const Erc1155ContractList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IContract>
  >("/erc1155/contracts", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc1155", "erc1155.contracts"]} />

      <PageHeader message="pages.erc1155.contracts.title" />

      <ProgressOverlay isLoading={isLoading}>
        <MuiGrid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(contract => (
              <MuiGrid size={{ lg: 4, sm: 6, xs: 12 }} key={contract.id}>
                <ContractListItem contract={contract} path="/erc1155/contracts" />
              </MuiGrid>
            ))}
          </StyledEmptyWrapper>
        </MuiGrid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
